
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account/bulk-rmi-request/new",
      function () {
        return require("private-next-pages/account/bulk-rmi-request/new.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account/bulk-rmi-request/new"])
      });
    }
  